import { ActionMap } from "library/ActionMap";
import { AccountInfo } from "library/hooks/types";
import { MakeRequired } from "library/utils";
import { Dispatch } from "react";

export enum PageType {
  LANDING = "LANDING",
  NO_EMAIL = "NO_EMAIL",
  STATEMENT_PREFERENCE = "STATEMENT_PREFERENCE",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  OTP = "OTP",
  JOINT_ACCOUNT = "JOINT_ACCOUNT",
}

export enum ActionType {
  ALL_DATA_LOADED = "ALL_DATA_LOADED",
  NO_EMAIL = "NO_EMAIL",
  ERROR = "ERROR",
  SUBMIT_FAILED = "SUBMIT_FAILED",
  SUCCESS = "SUCCESS",
  OTP = "OTP",
  OTP_SUCCESS = "OTP_SUCCESS",
  OTP_FAILED = "OTP_FAILED",
  JOINT_ACCOUNT = "JOINT_ACCOUNT",
}

export type StatementPreferenceType = {
  preference: "ONLINE" | "PAPER";
  feeWaived: boolean;
  feeWaivedExpiry: string;
  fee: number;
};

export type UserAddress =
  | {
      address1: string;
      address2: string;
      city: string;
      state: string;
      postCode: string;
      country: string;
    }
  | string;

export type PersonalDetails = {
  email: string;
  address: UserAddress | string;
};

export type State = {
  page: PageType;
  accountInfo?: AccountInfo;
  statementPreferences?: StatementPreferenceType;
  personalDetails?: PersonalDetails;
  submitUrl?: string;
  personalDetailsUnmaskedUrl?: string;
  createSessionUrl?: string;
};

export type PersonalDetailsResponse = {
  email: string;
  mobile_phone: string;
  home_phone?: string;
  work_phone?: string;
  residential: UserAddress;
};

type Payloads = {
  [ActionType.ALL_DATA_LOADED]: {
    accountInfo: AccountInfo;
    statementPreferences: StatementPreferenceType;
    personalDetails: PersonalDetails;
    submitUrl: string;
    createSessionUrl?: string;
    personalDetailsUnmaskedUrl: string;
  };
  [ActionType.NO_EMAIL]: {
    accountInfo: AccountInfo;
    personalDetails: PersonalDetails;
  };
  [ActionType.ERROR]: {
    accountInfo: AccountInfo;
  };
  [ActionType.SUCCESS]: {
    statementPreferences: StatementPreferenceType;
  };
  [ActionType.OTP_SUCCESS]: {
    personalDetails: PersonalDetails;
  };
  [ActionType.JOINT_ACCOUNT]: {
    accountInfo: AccountInfo;
  };
};

export type Action = ActionMap<ActionType, Payloads>;

export type ScreenState = MakeRequired<State, "accountInfo">;

export type ScreenProps = {
  state: ScreenState;
  dispatch: Dispatch<Action>;
};

export type ScreenComponentType = React.FC<ScreenProps>;
export type PageInfo = {
  [key: string]: {
    screenComponent: ScreenComponentType;
  };
};
